import React, { createContext, useContext, useEffect, useState } from "react";
import api, { formatApiError } from "./api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);     // null = loading, false = not authed, obj = authed
  const [meta, setMeta] = useState(null);

  useEffect(() => {
    (async () => {
      try {
        const { data } = await api.get("/auth/me");
        setUser(data);
      } catch { setUser(false); }
    })();
  }, []);

  useEffect(() => {
    if (!user) return;
    if (meta) return;
    (async () => {
      try {
        const { data } = await api.get("/meta");
        setMeta(data);
      } catch { /* meta is a non-critical lookup table - silent on transient failures */ }
    })();
  }, [user, meta]);

  async function login(email, password) {
    try {
      const { data } = await api.post("/auth/login", { email, password });
      setUser(data);
      return { ok: true };
    } catch (e) {
      return { ok: false, error: formatApiError(e.response?.data?.detail) || e.message };
    }
  }
  async function logout() {
    try { await api.post("/auth/logout"); } catch (e) { /* best-effort - proceed with local cleanup either way */ }
    setUser(false);
    setMeta(null);
  }
  return (
    <AuthCtx.Provider value={{ user, meta, setMeta, login, logout, setUser }}>
      {children}
    </AuthCtx.Provider>
  );
}

export function useAuth() { return useContext(AuthCtx); }
